/** 页面信息 */
const page = new (function () {
  this.title = '文号缺失查询'
  this.icon = 'iconfont iconicon_group'
  this.name = 'penalize_statistic_whqscx'
  /**菜单编号 */
  this.code = 'penalize_statistic_whqscx'
  /**菜单别名 */
  this.aliasName = 'menu'
  /**路由地址 */
  this.path = '/statistic/whqscx'
  //**接口权限 */
  this.permissions = []
})()

/** 路由信息 */
export const route = {
  page,
  component: () => import('./index.vue')
}

export default page
